/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class used for loan simulation response
 */
export type LoanSimulationDTO = {
    /**
     * Indicates which chronological group is used
     */
    chronoUnit?: LoanSimulationDTO.chronoUnit;
    /**
     * Value of the installment that will be paid
     */
    installmentValue?: number;
    /**
     * The interest rate will be paid
     */
    interestRate?: number;
    /**
     * Id of the simulation, used in loan application
     */
    simulationId?: string;
    /**
     * The total value that will be paid (including tax)
     */
    totalPayable?: number;
};

export namespace LoanSimulationDTO {

    /**
     * Indicates which chronological group is used
     */
    export enum chronoUnit {
        NANOS = 'Nanos',
        MICROS = 'Micros',
        MILLIS = 'Millis',
        SECONDS = 'Seconds',
        MINUTES = 'Minutes',
        HOURS = 'Hours',
        HALF_DAYS = 'HalfDays',
        DAYS = 'Days',
        WEEKS = 'Weeks',
        MONTHS = 'Months',
        YEARS = 'Years',
        DECADES = 'Decades',
        CENTURIES = 'Centuries',
        MILLENNIA = 'Millennia',
        ERAS = 'Eras',
        FOREVER = 'Forever',
    }


}
